import type { useDisconnect } from 'wagmi';

import clearSavedConnectionDetails from '@shared/helpers/web3/clearSavedConnectionDetails';
import truncate from '@shared/helpers/web3/truncate';

const validateMatchingAddresses = async ({
  userAddress,
  targetAddress,
  disconnectAsync,
}: {
  userAddress: string;
  targetAddress: string;
  disconnectAsync: ReturnType<typeof useDisconnect>['disconnectAsync'];
}) => {
  if (targetAddress.toLowerCase() !== userAddress.toLowerCase()) {
    await disconnectAsync();

    clearSavedConnectionDetails();

    const formattedUserAddress = truncate(userAddress);
    const formattedTargetAddress = truncate(targetAddress);

    throw new Error(
      `Invalid address: ${formattedUserAddress}.\nPlease connect to ${formattedTargetAddress} in your wallet app/extension to continue.`,
    );
  }
};

export default validateMatchingAddresses;
